import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ConditionsRegistryService } from '@sdbn/common-extended';
import { PositionConditionEditorComponent } from './current-position-condition-editor/position-condition-editor.component';
import { StructureSelectionModule } from '../../common/structure-selection/structure-selection.module';
import { TmcContextService } from '../../common/tmc-context.service';
import { YardConfiguration } from '../../client/model/yard-configuration';
import { StationTypeConditionEditorComponent } from './current-station-type-editor/station-type-condition-editor.component';
import { ApplicationClientCommonModule, TranslationService } from "@sdbn/common";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";



@NgModule({
  declarations: [
    PositionConditionEditorComponent,
    StationTypeConditionEditorComponent
  ],
  imports: [
    CommonModule,
    StructureSelectionModule,
    ApplicationClientCommonModule,
    ReactiveFormsModule,
    FormsModule
  ]
})
export class StationConditionsModule {

  yardConfiguration: YardConfiguration;

  constructor(
    private conditionsRegistryService: ConditionsRegistryService,
    private tmcContextService: TmcContextService,
    private translationService: TranslationService
  ) {
    this.tmcContextService.updated.subscribe(
      yardConfiguration => {
        this.yardConfiguration = yardConfiguration;
      }
    );

    this.conditionsRegistryService.registerTemplateGroup({
      titleDictionaryKey: 'CONDITIONS.ENTRIES.TEMPLATES.GROUPS.COMMON',
      anchors: ['station'],
      templates: [
        {
          titleDictionaryKey: 'tmc-yard.ui.admin.filter-administration.filter-conditions.current-station-type',
          key: 'station-type',
          iconCss: 'fa-cog',
          editor: StationTypeConditionEditorComponent,
          summaryProvider: (data: string, language: string) => Promise.resolve(data ? translationService.translate('tmc-yard.common.enum.station-type.' + data) : '')
        },
        {
          titleDictionaryKey: 'tmc-yard.ui.admin.filter-administration.filter-conditions.current-station-is-intern',
          key: 'station-is-intern',
          iconCss: 'fa-cog',
          editor: null,
          summaryProvider: (data: string, language: string) => Promise.resolve('')
        },
        {
          titleDictionaryKey: 'tmc-yard.ui.admin.filter-administration.filter-conditions.current-station-is-extern',
          key: 'station-is-extern',
          iconCss: 'fa-cog',
          editor: null,
          summaryProvider: (data: string, language: string) => Promise.resolve('')
        },
        {
          titleDictionaryKey: 'tmc-yard.ui.admin.filter-administration.filter-conditions.current-position',
          key: 'transport-current-position',
          iconCss: 'fa-cog',
          editor: PositionConditionEditorComponent,
          summaryProvider: (data: string, language: string) => Promise.resolve(this.getLocationName(data))
        },
        {
          titleDictionaryKey: 'tmc-yard.ui.admin.filter-administration.filter-conditions.next-processing-position',
          key: 'transport-next-processing-position',
          iconCss: 'fa-cog',
          editor: PositionConditionEditorComponent,
          summaryProvider: (data: string, language: string) => Promise.resolve(this.getLocationName(data))
        },
        {
          titleDictionaryKey: 'tmc-yard.ui.admin.filter-administration.filter-conditions.position-in-route',
          key: 'transport-position-in-route',
          iconCss: 'fa-cog',
          editor: PositionConditionEditorComponent,
          summaryProvider: (data: string, language: string) => Promise.resolve(this.getLocationName(data))
        }
      ]
    });

  }

  private getLocationName(data: string): string {
    if (data && data != '') {
      let configuration = JSON.parse(data);
      let result = '';
      if (configuration['stationGroupId'] != null) {
        result += this.yardConfiguration.getStationGroupById(configuration['stationGroupId'])?.name;
      }
      if (configuration['stationSetId'] != null) {
        result += ', ';
        result += this.yardConfiguration.getStationSetById(configuration['stationSetId'])?.name;
      }
      if (configuration['stationId'] != null) {
        result += ', ';
        result += this.yardConfiguration.getStationById(configuration['stationId'])?.name;
      }
      return result;
    } else {
      return 'no location';
    }
  }

}
